import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Totalcounts from 'components/TotalCounts';
import { Link } from 'react-router-dom';
import styles from './Community.scss';// to import local scss fle

class Community extends Component {
  constructor(props) {
    super(props);
    this.state = {
      athleteShowMoreText: false,
      parentShowMoreText: false,
      coachShowMoreText: false,
    };
    this.handleShowMoreTest = this.handleShowMoreTest.bind(this);
  }
  handleShowMoreTest = (name) => {
    this.setState({ ...this.state, [name]: true });
  };
  render() {
    const { athleteShowMoreText, parentShowMoreText, coachShowMoreText } = this.state;
    return (
      <div className={cn('row', styles.communityContainer)}>
        <div className={cn('col s12 l4', styles.categories)}>
          <div className={cn('col s12', styles.athleteIcon)}>
            <img alt="Athelete" src="https://media.dev.myrecruitboard.com/Images/athketes%403x.png" />
          </div>
          <div className={styles.categoryHeader}><h1>ATHLETES</h1></div>
          <div className={cn('col s12', styles.categoryDescription)}>
            {athleteShowMoreText === true ?
              <div className={styles.textContainer}>
                  RECRUITING PROBLEMS:<br />
                  Underexposed?<br />
                  Not being recruited?<br />
                  Live in a small town?<br />
                  Got letters, but no offers?<br />
                  Know players younger than you getting offers?<br />
                  Has a college coach has stopped communicating with you?<br /> <br />

                  You will not get a scholarship by randomly tagging coaches to your
                  Hudl video on Twitter.  College coaches use trusted companies to
                  recruit prospects. Randomly contacting a college coach will most often go
                  unanswered or lead to nowhere.  Save your time and use our website to get
                  recruited today.  We help football players in every situation get
                  recruited. <br /><br />

                  YOUR SOLUTION: <br />
                  Make a profile to discover hundreds of colleges looking to recruit
                  players matching your biometrics and academic standings.<br />
                <span><Link to="/register">Join Now</Link></span>
              </div>
                            :
              <div className={styles.textContainer}>
                    Underexposed?
                    Not being recruited?
                    Live in a small town?
                    Got letters, but no offers?
                    Know players younger than you getting offers?
                    Has a college coach has stopped communicating with you?
                    {/* eslint-disable */}
                    ...<span onClick={() => this.handleShowMoreTest('athleteShowMoreText')}>show more</span>
                    {/* eslint-enable */}
                <span><Link to="/register">Join Now</Link></span>
              </div>
                        }
          </div>
        </div>
        <div className={cn('col s12 l4', styles.categories)}>
          <div className={cn('col s12', styles.parentIcon)}>
            <img alt="Parents" src="https://media.dev.myrecruitboard.com/Images/parents%402x.png" />
          </div>
          <div className={styles.categoryHeader}><h1>PARENTS</h1></div>
          <div className={cn('col s12', styles.categoryDescription)}>
            {parentShowMoreText === true ?
              <div className={styles.textContainer}>
                  RECRUITING PROBLEMS: <br />
                  Is your son more talented, bigger, stronger, faster, or smarter than other
                  players being seriously recruited?<br />
                Don&apos;t believe this statement: &quot;If he&apos;s
                talented they will find him.&quot; <br /> <br />
                Likewise, don&apos;t let the school he attends,
                where you live or his coach&apos;s &quot;connections&quot;
                limit your son&apos;s ability to get recruited.<br /> <br />
                YOUR SOLUTION:<br />
                  We help families get the most academic and
                athletic scholarship money
                possible to pay for the high cost of a college education.
                Make a profile to discover hundreds of colleges looking to recruit players
                matching your son&apos;s biometrics and academic standings.
                <br />
                <span><Link to="/register">Join Now</Link></span>
              </div>
                            :
              <div className={styles.textContainer}>
                Is your son more talented, bigger, stronger, faster, or smarter than other
                players being seriously recruited?
                Don&apos;t believe this statement: &quot;If he&apos;s
                talented they will find him.&quot;
                Likewise, don&apos;t let
                {/* eslint-disable */}
                ...<span onClick={() => this.handleShowMoreTest('parentShowMoreText')}>show more</span>
                {/* eslint-enable */}
                <br />
                <span><Link to="/register">Join Now</Link></span>
              </div>
                        }
          </div>
        </div>
        <div className={cn('col s12 l4', styles.categories)}>
          <div className={cn('col s12', styles.cocahIcon)}>
            <img alt="Coaches" src="https://media.dev.myrecruitboard.com/Images/coaches%402x.png" />
          </div>
          <div className={styles.categoryHeader}><h1>COACHES</h1></div>
          <div className={cn('col s12', styles.categoryDescription)}>
            {coachShowMoreText === true ?
              <div className={styles.textContainer}>
                  RECRUITING PROBLEMS: <br />
                  Building a new program? <br />
                  Unfamiliar recruiting area?<br />
                  Need to find quality talent?<br />
                  Newly hired staff member?<br />
                  Very specific academic type?<br />
                  Hard-to-sell college or location?<br />
                  Need to recruit at a lower level of play?<br />
                  Need to find under-recruited D1 talent?<br /><br />

                  YOUR SOLUTION: <br />
                  Let us find the best players you need and want.<br />
                  Connect directly with the recruits that you want.<br />
                  Evaluate the recruits that have shown interest in your team.<br />
                <br />
                <span><Link to="/register">Join Now</Link></span>
              </div>
                            :
              <div className={styles.textContainer}>
                  Building a new program?
                  Unfamiliar recruiting area?
                  Need to find quality talent?
                  Newly hired staff member?
                  {/* eslint-disable */}
                  ...<span onClick={() => this.handleShowMoreTest('coachShowMoreText')}>show more</span>
                  {/* eslint-enable */}
                <br />
                <span><Link to="/register">Join Now</Link></span>
              </div>
                        }
          </div>
        </div>
        <div className={cn('col s12', styles.ourCommunity)}>
          <h1>OUR MISSION</h1>
          <span>
            <div className={styles.communityText}>
            The mission of MyRecruitBoard is simple.<br />
            To expose every football player in America to the colleges they fit
            best using our cutting edge technology.
            Ultimately making their recruitment affordable, productive, and successful.
        </div>
          </span>
        </div>
        <div className={cn('col s12', styles.countsContainer)}>
          <Totalcounts />
        </div>
      </div>
    );
  }
}
export default Community;



// WEBPACK FOOTER //
// ./src/components/Community/Community.js